import React from 'react';
import * as Sentry from '@sentry/react';

export default class ConsentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ConsentErrorBoundary] Error caught:', error, errorInfo);
    
    // Capture error in Sentry with context
    Sentry.captureException(error, {
      tags: {
        component: 'ConsentManager',
        errorBoundary: true,
      },
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
      extra: {
        errorBoundary: 'ConsentErrorBoundary',
      },
    });
  }

  render() {
    if (this.state.hasError) {
      // Fail gracefully - render children anyway
      // Consent management is non-critical for app functionality
      console.warn('[ConsentErrorBoundary] ConsentManager error - continuing without consent management');
    }
    return this.props.children;
  }
}
